// extracted by mini-css-extract-plugin
module.exports = {"redirect_link":"redirect_link_redirect_link__2kOus"};